import React, {useContext, createContext, useState, useMemo} from 'react'
import PropTypes from 'prop-types'
import {useLocation} from 'react-router-dom'

const YR_PATH = '/yellow-rose'

export const SiteContext = createContext()
export const useSiteContext = () => useContext(SiteContext) || {}

export const SiteProvider = ({children}) => {
    const value = useSiteProvider()

    return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>
}

SiteProvider.propTypes = {
    children: PropTypes.node.isRequired
}

const useSiteProvider = () => {
    const location = useLocation()
    const isYR = location.pathname.includes(YR_PATH)
    const isKS = !isYR
    const [openBonusModal, setOpenBonusModal] = useState(false)
    const [forceOpenGwpDrawer, setForceOpenGwpDrawer] = useState(false)
    const [editBonusItemInCart, setEditBonusItemInCart] = useState(false)
    const value = useMemo(
        () => ({
            isYR,
            isKS,
            openBonusModal,
            setOpenBonusModal,
            editBonusItemInCart,
            setEditBonusItemInCart,
            forceOpenGwpDrawer,
            setForceOpenGwpDrawer
        }),
        [isYR, isKS, openBonusModal, forceOpenGwpDrawer]
    )

    return value
}
